import { TABS } from 'src/pages/CaseDetails/constants';
import { STATUS } from 'src/pages/CaseDetails/constants/EmiSchedule.component';
import { Due } from 'src/pages/CaseDetails/interfaces/CaseDetail.type';

export const validateSelectedTab = (tabName: string) => {
  if (TABS.some(tab => tab.key === tabName)) return true;
  return false;
};

export const createKey = (lan: string, customerID: string) => {
  return `${lan}_${customerID}`;
};

export const isOverdue = (item: Due) => item?.status === STATUS.UNPAID;

export const isPaid = (item: Due) => item?.status === STATUS.PAID;

export const isForeclosed = (item: Due) => item?.status === STATUS.FORECLOSED;

export const isPartiallyPaid = (item: Due) => item?.status === STATUS.PARTIALLY_PAID;

export const isNumericLength = (value: string) => !isNaN(Number(value));
